import { Component } from "react";
import * as React from "react";
import { Link } from "react-router-dom";

export interface LinkCardSmallProps {
    title: string
    description: string;
    image: string;
    footerListItems?: string[];

    href?: string;
    onClick?: () => void;
}

interface LinkCardSmallState {
}

export default class LinkCard extends Component<LinkCardSmallProps, LinkCardSmallState>
{

    constructor(props: Readonly<LinkCardSmallProps>) {
        super(props);

        this.state = {
        };
    }

    public componentDidMount() {
    }

    public renderFooter() {
        if (this.props.footerListItems == undefined) {
            return null;
        }

        let listItems = this.props.footerListItems.map((value) => {
            return <li>{value}</li>;
        })

        return <ul>{listItems}</ul>
    }

    private renderContent() {
        return <div className="help-box-item help-box-item--narrow">
            <span className="help-box-item__title">
                {this.props.title}
            </span>
            <span className="help-box-item__description">
                {this.props.description}
            </span>
            <div className="help-box-item__image-container">
                <img src={this.props.image} className="help-box-item__image-container__image" />
                {this.props.children}
            </div>
            {this.renderFooter()}
        </div>
    }


    public render() {
        if (this.props.href) {
            return <Link to={this.props.href} onClick={this.props.onClick}>
                {this.renderContent()}
            </Link>
        }
        else {
            return <div onClick={this.props.onClick}>
                {this.renderContent()}
            </div>
        }
    }
}